var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPortcallSidebarVisible)?_c('portcall-list',{attrs:{"is-from-custom-sidebar":""}}):(_vm.isQuaySidebarVisible)?_c('quay-list',{attrs:{"is-from-custom-sidebar":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }